const authConfig = {
  roles: [
    {
      id: 1,
      name: "Owner",
      value: "owner",
      icon: "🚗",
      description: "List and manage your personal vehicles",
    },
    {
      id: 2,
      name: "Agent",
      value: "agent",
      icon: "🤝",
      description: "List vehicles on behalf of clients",
    },
  ],

  pages: {
    login: {
      role: false,
      title: "Welcome Back",
      subtitle: "Sign in to continue to your account",
      submitLabel: "Login",
      roleLabel: "Select Role",
      fields: [
        {
          name: "identifier",
          label: "Email or Phone",
          type: "text",
          placeholder: "Enter email or phone number",
          layout: "full",
        },
        {
          name: "password",
          label: "Password",
          type: "password",
          placeholder: "Enter your password",
          layout: "full",
        },
      ],
      footer: {
        text: "Don't have an account?",
        linkText: "Sign Up",
        action: "signup",
      },
      forgotPassword: {
        show: true,
        text: "Forgot Password?",
        action: "forgot",
      },
    },

    signup: {
      role: false,
      title: "Create Account",
      subtitle: "Join CarZone and start your journey",
      submitLabel: "Sign Up",
      roleLabel: "Select Role",
      fields: [
        {
          name: "name",
          label: "Full Name",
          type: "text",
          placeholder: "Enter your full name",
          layout: "half",
        },
        {
          name: "phone",
          label: "Phone Number",
          type: "tel",
          placeholder: "Enter phone number",
          layout: "half",
        },
        {
          name: "email",
          label: "Email Address",
          type: "email",
          placeholder: "Enter email address",
          layout: "full",
        },
        {
          name: "password",
          label: "Password",
          type: "password",
          placeholder: "Create a password",
          layout: "half",
        },
        {
          name: "confirmPassword",
          label: "Confirm Password",
          type: "password",
          placeholder: "Confirm your password",
          layout: "half",
        },
      ],
      footer: {
        text: "Already have an account?",
        linkText: "Login",
        action: "login",
      },
    },

    forgotPassword: {
      role: false,
      title: "Forgot Password",
      subtitle: "Enter your email and we'll send you a reset link",
      submitLabel: "Send Reset Link",
      roleLabel: "Select Role",
      fields: [
        {
          name: "email",
          label: "Email Address",
          type: "email",
          placeholder: "Enter your registered email",
          layout: "full",
        },
      ],
      footer: {
        text: "Remember your password?",
        linkText: "Back to Login",
        action: "login",
      },
    },
  },
};

export default authConfig;
